import { createEpicMiddleware } from "redux-observable";
import { rootEpic, dependencies } from "../ducks/epics";

export default createEpicMiddleware(rootEpic, {
  dependencies
});
